import React from 'react';
import PageLayout from '../components/layout/PageLayout';
import ContactForm from '../components/contact/ContactForm';
import { Link } from 'react-router-dom';

const ContactVisaPage = () => {
  return (
    <PageLayout title="Contact - Visa">
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          {/* Breadcrumb */}
          <nav className="mb-6">
            <ol className="flex items-center space-x-2 text-sm text-gray-500">
              <li><Link to="/" className="hover:text-gray-700">Home</Link></li>
              <li>/</li>
              <li><Link to="/visa" className="hover:text-gray-700">Visa</Link></li>
              <li>/</li>
              <li className="text-gray-900">Contact</li>
            </ol>
          </nav>

          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Visa Information Request</h1>
            <p className="text-lg text-gray-600">
              Get expert visa guidance and the latest requirements. Submit your inquiry below and our team will provide you with up-to-date visa information, application guidance, and support.
            </p>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <ContactForm category="visa" />
          </div>

          {/* Additional Info */}
          <div className="mt-8 bg-green-50 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-green-900 mb-3">What to Expect</h3>
            <ul className="space-y-2 text-green-800">
              <li>• We'll respond within 24 hours during business days</li>
              <li>• Get the latest visa requirements and processing times</li>
              <li>• Receive step-by-step application guidance</li>
              <li>• Access to visa updates and policy changes</li>
            </ul>
          </div>

          {/* Back to Visa */}
          <div className="mt-6 text-center">
            <Link 
              to="/visa" 
              className="inline-flex items-center px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
            >
              ← Back to Visa
            </Link>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default ContactVisaPage;
